export class LocalizeHelper {
  static getLocaleData(data: any, locale: string) {
    if (typeof data == 'object' && data['@type'] && data['@type'] == '@builder.io/core:LocalizedValue') {
      data = data['Default'] ?? '';
      if (data[locale]) {
        data = data[locale];
      }
    }

    return data;
  }
}
